import { z } from 'zod'
import { sanitizeString } from '../reportingTool/reportingUtils'
import { DonateSchema } from './schema'

export const convertDonateToFormData = (
  data: z.infer<typeof DonateSchema>,
  token: string,
): FormData => {
  const formData = new FormData()

  formData.append('token', token)
  formData.append('firstName', sanitizeString(data.firstName))
  formData.append('lastName', sanitizeString(data.lastName))
  formData.append('email', sanitizeString(data.email))
  formData.append('phoneNumber', sanitizeString(data.phoneNumber || ''))
  formData.append('zipCode', sanitizeString(data.zipCode))
  formData.append('donationAmount', sanitizeString(data.donationAmount))
  formData.append('message', sanitizeString(data.message || ''))

  return formData
}